var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('AboutUsHomeHeader'),_c('section',{staticClass:"form-full-width"},[_c('FormAboutUsHome',{attrs:{"loading":_vm.loading,"getAboutUsHome":_vm.getAboutUsHome},on:{"beforeUpdate":_vm.updateAboutUsHome}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }